import React, { useEffect, useState, useContext } from "react";
import { makeStyles, Theme, createStyles, withStyles, ClassNameMap } from "@mui/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {DataContext, PolicyContext, DirtyContext} from "~common/form/icg-definition-data-provider";
import DefinitionSection from "~common/form/definition-section-fc";
// import DefinitionDataProvider, {DataContext,} from "~common/form/icg-definition-data-provider";
import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import { extend } from "lodash";
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";
import { APIError } from "~common/lib/types";
import {
  IconButton,
  Button,
  Menu,
  MenuItem,
  ListItemText,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Tooltip,
} from "@mui/material";

import { saveAs } from "file-saver";

import { getValueAtPath } from "~common/form/helper";

import { clone, cloneDeep } from "lodash";

import PortalUserSubscription from "~common/lib/models/portal-user-subscription";

import PortalUserContext from "~common/lib/portal-user-context";

// import SuccessView from '~common/components/success-view';
import LoadingView from "~common/components/loading-view";

// import DefinitionSection from "~common/form/definition-section";

import { Definition } from "~common/lib/types";
import { setValueAtPathWithOpts } from "~common/form/helper";
import DashboardCardConfig from "~dashboard/components/dashboard-card-config-fc";
import QueryResultView from "./components/query-result-view-fc";
import QueryCriteriaView from "./components/query-criteria-view-fc";
import { QueryResultsSummaryArea } from "./query-results-summary-area";
import SummaryDialog from "./summary-dialog-form";
import DataExtractDialog from "./data-extract-dialog-form";
import HidableResultsDialog from "./hidable-results-dialog-form";
import TemplateDialog from "./template-renderer";
import Pager from "./components/query-list-pager-fc";

import ErrorView from "~common/components/error-view";
import SuccessView from "~common/components/success-view";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import CookieManager from "~common/lib/cookie-manager";

import Renderers from "~common/lib/renderers";

import {HotKeyMappingContext} from "~common/components/app-view/index";

var entityID = 0;

export interface SSEActionProps {
  eventListenerURL: string;
  eventFunction: Function;
}

export interface SummaryAction {
  // label is the text that will be displayed in the summary actions drop down
  label: string;

  // form that will be presented to the user if the summary action is selected.  Will be used in favor of the form selector, if provided.
  form: any;

  // formSelector is the form that will be presented to the user if the summary action is selected.
  formSelector: any;

  // allow one to override the props for the compelte button.  `label` will be used as the prop for the button text
  formCompleteButtonProps?: any;

  // allow one to override the props for the cancel button.  `label` will be used as the prop for the button text
  formCancelButtonProps?: any;

  onClick?: Function;

  // onFormComplete is called when the form is completed by the user.
  // `done` is called with the action is complete to dismiss the modal and trigger and update of the results list automatically.
  onFormComplete?: (
    items: Array<any>,
    action: SummaryAction,
    formData: any,
    cancel: boolean,
    done: Function
  ) => void;
}

interface SummaryOperation {
  action: SummaryAction;
  items: Array<any>;
}

let selectionColor = "orange";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hover: {
      "&:hover": {
        backgroundColor: "#dcdbdc",
        border: "solid #b8b8b8 1px",
      },
      border: "solid #ffffff 1px",
    },
    container: {
      width: "100%",
    },
    listFunctionLine: {
      display: "flex",
      justifyContent: "space-between",
    },
    addNewRow: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    addNewSection: {
      padding: 15
    },
    addNewRowNoResults: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 15,
    },
    listTitle: {
      marginBottom: 10,
      paddingLeft: 15 ,
    },
    sectionTitle: {
      // fontSize: "0.9rem",
      marginBottom: 10,
      fontSize: "1.3125rem",
      fontWeight: 500,
      fontFamily: "Roboto,Arial,sans-serif",
      lineHeight: "1.16667em",
      paddingLeft: 8,
    },
    listFunctions: {
      display: "flex",
      justifyContent: "flex-end",
    },
    listFunctionButton: {
      // color: "#8d8d8d",
      fontSize: "1.0rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    listFunctionButtonIcon: {
      minWidth: "1.0rem",
    },
    criteriaSection: {
      padding: 10,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    paper: {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    summaries: {
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 0px #FFFFFF;none",
      padding: theme.spacing(4),
    },
    resultsSection: {
      padding: 10,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    noResultsSection: {
      padding: 30,
      paddingBottom: 15,
      boxShadow: "0px 0px 0px #FFFFFF;none",
      display: "flex",
      justifyContent: "center",
    },
    // An alternate to the above used when returning multiples
    resultsListSection: {
      padding: 10,
      marginTop: 15,
      boxShadow: "0px 0px 0px #FFFFFF;none",
    },
    pagerArea: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    pager: {},
    evenRow: {
      backgroundColor: "#fff",
      padding: "10px 5px 5px 5px",
      borderBottom: "1px solid #ccc",
    },
    oddRow: {
      backgroundColor: "#f0f0f0",
      padding: "10px 5px 5px 5px",
      borderBottom: "1px solid #ccc",
    },
    clickableRow: {
      cursor: "pointer",
    },
    buttonBar: {
      display: "flex",
      justifyContent: "space-between",
      spaceBetween: 15,
      padding: 15,
      paddingBottom: 0,
      paddingTop: 0,
    },
    addBar: {
      display: "flex",
      justifyContent: "flex-start",
      paddingBottom: 0,
    },
    sortArea: {
      justifyContent: "flex-start",
      alignItems: "center",
      minHeight: 50,
      minWidth: 150,
    },
    sortOptions: {
      maxWidth: 300,
      minWidth: 150,
      marginRight: 30,
      width: "100%",
    },
    sortOptionIcon: {
      marginLeft: 5,
    },
    buttonArea: {
      marginTop: 15,
      justifyContent: "flex-end",
      minHeight: 50,
      minWidth: 180,
    },
    buttonSubmit: {
      marginLeft: "15px !important",
    },
    buttonAddNew: {
      marginLeft: 15,
      marginRight: 15,
      justifyContent: "flex-end",
    },
    buttonCancel: {
      paddingLeft: 15,
    },
    noResultsText: {
      display: "flex",
      justifyContent: "center",
      paddingLeft: 15,
    },
    simulationWarning: {
      border: "1px solid #fdde00",
      backgroundColor: "#fffedc",
      padding: 15,
      marginBottom: 15,
      textAlign: "center",
    },
    selectedRow: {
      border: "1px solid " + selectionColor,
      margin: 1,
    },
    summaryActionPolicyMessages: {
      border: "2px solid red",
      margin: 1,
    },
    unselectedRow: {
      border: "1px solid rgba(255,255,255,0.0)",
      margin: 1,
    },
    selectionActionArea: {
      display: "flex",
      justifyContent: "space-between",
      textAlign: "right",
      paddingLeft: 6,
      paddingRight: 5,
      paddingBottom: 0,
      verticalAlign: "baseline",
      minHeight: 45,
      marginBottom: 5,
    },
    selectionCount: {
      display: "inline-block",
      width: "40%",
      textAlign: "center",
      paddingTop: 10,
    },
    selectionAction: {
      display: "inline-block",
      width: "30%",
    },
    allSelectors: {
      display: "inline-block",
      width: "30%",
      color: "#333",
      textAlign: "left",
      paddingTop: 10,
    },
    selector: {
      color:
        theme.overrides &&
        theme.overrides.MuiButton &&
        theme.overrides.MuiButton.raisedPrimary &&
        theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
    },
    select: {
      color:
        theme.overrides &&
        theme.overrides.MuiButton &&
        theme.overrides.MuiButton.raisedPrimary &&
        theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
      display: "inline-block",
      cursor: "pointer",
    },
    unselect: {
      color:
        theme.overrides &&
        theme.overrides.MuiButton &&
        theme.overrides.MuiButton.raisedPrimary &&
        theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
      display: "inline-block",
      marginLeft: 15,
      cursor: "pointer",
    },
    summaryActionMessage: {
      fontWeight: 600,
      paddingBottom: 10,
      color:
        theme.overrides &&
        theme.overrides.MuiButton &&
        theme.overrides.MuiButton.raisedPrimary &&
        theme.overrides.MuiButton.raisedPrimary.backgroundColor
          ? theme.overrides.MuiButton.raisedPrimary.backgroundColor
          : selectionColor,
      fontStyle: "italic",
    },
  })
);

export interface RowItemAction {
  label: string;
  onClick: Function;
}

interface ButtonProps {
  label?: any;
  variant?: any;
  color?: any;
}

interface SummaryOperation {
  action: SummaryAction;
  items: Array<any>;
}

const StyledMenuItem = withStyles((theme) => ({
  root: {
    minWidth: 150,
    height: 30,
    padding: 3,
    color: "black",
    "&:focus": {
      // backgroundColor: theme.palette.primary.main,
      backgroundColor: theme.palette.common.white,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.black,
      },
    },
  },
}))(MenuItem);

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

interface QueryListProps {
  history?: any;
  // Classes can be passed in to control look and feel, such as `evenRow` and `oddRow`
  classes: any;
  // The URL to be used when selecting forms
  formSelectorUrl?: string;
  // The URL to be used when performing the query
  queryUrl?: string;
  // If necessary, data fulfillment can also be handled by the parent.
  queryFn?: Function;
  // The timeout to allow for fulfillment.  This can be useful in long running transactions.
  queryTimeoutSec?: number;
  // Indicates that when criteria are on the URL when the page is loaded, the query will automatically be executed.
  autoQuery?: boolean;

  //Signals that this form allows for adding new items. Adds a 'Add New' button that directs the user to the provided URL
  addNewUrl?: string;

  // Indicates that when first loading a page, a search will be executed regardless of empty criteria.
  // TODO: Possibly move this into core.
  forceExecuteOnLoad?: boolean;
  // The criteria form is the form that is used to collect the criteria
  alwaysExecuteOnSubmit?: boolean;

  // Custom Renderers to be used in the criteria AND results forms
  customRenderers?: any;

  // custom section renderer
  customSectionRenderer?: any;

  // Custom messages to be provided to the criteria AND results forms
  customMessages?: any;

  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  // The criteria form.  Either this or a valid selector must be provided
  criteriaForm?: any;
  // The criteria form selector.  Either this or a valid form must be provided
  criteriaFormSelector?: any;
  // Determines whether the outbound form will be pruned of options and other unnecessary information that
  pruneCriteriaForm?: boolean;

  // This function, if passed, is called when the critieria form is renders, allows client-land tweeks
  onCriteriaFormSelection?: Function;

  // onEvaluateConditional is called when the form conditionals are evaluated.
  onEvaluateConditional?: Function;

  // hide criteria
  suppressCriteriaView?: boolean;

  // Default the criteria view as collapsed
  defaultCriteriaCollapsed?: boolean

  resultsForm?: any;
  // The results form selector.  Either this, a valid form, or results columns (only supported in `table` mode) must be provided
  resultsFormSelector?: any;
  // The columns to be displayed in the grid, which is rendered only when the mode is `table`
  resultsColumns?: boolean;
  // The function to be called when the row is clicked.
  onRowClick?: Function;
  // The array of actions to be made available for each row.

  actionsForSelectedItems?: Function;
  // signals that the selection should be enabled.  This function will be called

  // This will be called when the summaryFunction is clicked instead of the internal function
  // handleSummaryMenuClick?: Function
  summaryActionMessage?: string;

  actionsForItemRow?: Function;

  // Reserves the layout space for row actions regardless of whether row actions are available.
  // This help when trying to keep row with and without actions alinged.
  reserveRowActionSpace?: boolean;
  // The text for the clear button
  clearButtonText?: string;
  // The text for the submit button
  submitButtonText?: string;
  // A set of props to control the appearance of the submit button
  submitButtonProps?: ButtonProps;
  // A set of props to control the appearance of the cancel button
  cancelButtonProps?: ButtonProps;
  // The variant to use.  Defaults to `normal`
  variant?: "normal" | "single" | "table";
  // The text to be displayed the query is sucessful, but no results are returned.
  noResultsText?: string;
  // The function to get noResultsText, if provided will be used ahead of the noResultsText prop.
  getNoResultsText?: any;
  // The starting page size.
  pageSize?: number;

  // Fields that will be excluded from being cleared then the Criteria Clear button is clicked.
  excludeFromClear?: Array<string>;

  // don't show status icon at begining of section title
  supressSectionStatusIcon?: boolean;

  // Allow the caller to suppress the use of the URL manager
  suppressURL?: boolean;
  // By default, only when the criteria changed and the submit is initiated that the query is executed.
  // This setting allows you to indicate that the query should always be executed, even if the criteria has not changed.

  suppressExport?: boolean;

  suppressDashboardCard?: boolean;

  // do not show the paging controls
  suppressPaging?: boolean;

  // if an export to a different format is needed, provide the exportContentType.  This is the content type that will be passed back to the fulfillment handler.
  exportContentType?: string;

  // exportFileNameBase is the base name of the file that will be downloaded.
  // If not provided, the `exportFileNameBase` on the results form will be used.
  // Finally if that is not provided, the key of the results form will be used.
  exportFileNameBase?: string;

  // The results form.  Either this or a valid selector must be provided

  suppressTitle?: boolean;

  suppressFirstTitle?: boolean;

  // Strings passed to the definition section that will replace the title in the form definition
  criteriaTitleOverride?: string;
  resultsTitleOverride?: string;

  // In some cases, you may not want the user to be able to collapse sections
  preventCollapse?: boolean;

  // Indicates wheterh a subscription should be allowed for this query
  allowSubscription?: boolean;

  summaryRenderer?: any;

  // handleCriteriaChange
  handleCriteriaChange?: (path: string, data: any) => any;

  // Hide scroll top
  disallowScrollTop?: boolean;

  // Handler for EventSource Live updates
  // eventSourceURL?: string;

  // Apply alpha sort to sort options
  alphabetizeSortOptions?: boolean;

  // SSE Action
  sseActionProps?: SSEActionProps;
}

export const QueryList: React.FC<QueryListProps> = ({
  history,
  classes,
  formSelectorUrl,
  queryUrl,
  queryFn,
  queryTimeoutSec,
  autoQuery,
  addNewUrl,
  forceExecuteOnLoad,
  alwaysExecuteOnSubmit,
  customRenderers,
  customSectionRenderer,
  customMessages,
  gridSpacing,
  criteriaForm,
  criteriaFormSelector,
  pruneCriteriaForm,
  onCriteriaFormSelection,
  onEvaluateConditional,
  suppressCriteriaView,
  defaultCriteriaCollapsed,
  resultsForm,
  resultsFormSelector,
  resultsColumns,
  onRowClick,

  actionsForSelectedItems,

  summaryActionMessage,

  actionsForItemRow,

  reserveRowActionSpace,
  clearButtonText,
  submitButtonText,
  submitButtonProps,
  cancelButtonProps,
  variant,
  noResultsText,
  getNoResultsText,
  pageSize,
  excludeFromClear,
  supressSectionStatusIcon,
  suppressURL,
  suppressExport,
  suppressDashboardCard,
  suppressPaging,
  exportContentType,
  exportFileNameBase,
  suppressTitle,
  criteriaTitleOverride,
  resultsTitleOverride,
  preventCollapse,
  allowSubscription,
  summaryRenderer,
  handleCriteriaChange,
  disallowScrollTop,
  // eventSourceURL,
  alphabetizeSortOptions,
  sseActionProps,
}) => {

  // Attempt to get the initial page size
  var pageSizeInit: any;
  var ps = CookieManager.getCookie(
    `queryListPageSizeInit|${window.location.pathname}`
  );
  if (ps != "") {
    pageSizeInit = Number(ps);
    if (isNaN(pageSizeInit)) {
      pageSizeInit = undefined;
    }
  }

  const [_status, setStatus] = useState("loading");
  const [_setForceRender, setForceRender] = useState(false);
  const [_loadingText, setLoadingText] = useState("Loading");

  const [_error, setError] = useState(null);
  const [_hasExecutedQuery, setHasExecutedQuery] = useState(false);
  // 
  const [hideResults, setHideResults] = useState(false);
  // const [_subscriptionConfig, setSubscriptionConfig] = useState(null);

  // // Paging defaults
  const [_currentPage, setCurrentPage] = useState(0);
  const [_pageSize, setPageSize] = useState(pageSize || pageSizeInit || 10);
  const [_resultCount, setResultCount] = useState(0);

  // const [submitButtonProps, setSubmitButtonProps] = useState(
  //   submitButtonPropsInit
  // );
  // const [cancelButtonProps, setCancelButtonProps] = useState(
  //   cancelButtonPropsInit
  // );
  const [_summaryMenuOpen, setSummaryMenuOpen] = useState(false);
  const [_summaryMenuAnchorEl, setSummaryMenuAnchorEl] = useState(null);
  const [_templateRenderer, setTemplateRenderer] = useState(null);
  const [_success, setSuccess] = useState(null);
  const [_resultsForm, setResultsForm] = useState(null);
  const [_dashboardConfig, setDashboardConfig] = useState(null);
  const [_resultsColumns, setResultsColumns] = useState(false);
  const [_criteriaForm, setCriteriaForm] = useState(null);
  const [_loadingExport, setLoadingExport] = useState(false);
  const [_confirmSubscribe, setConfirmSubscribe] = useState(null);
  const [_summaryOperation, setSummaryOperation] = useState(null);
  const [_extractionDefinition, setExtractionDefinition] = useState(null);
  const [_hidableResultsOpen, setHidableResultsOpen] = useState(null);

  const [fullData, setFullData] = useState([])
  const [_criteria, setCriteria] = useState(null);

  const [policyMessages, setPolicyMessages] = useState([])

  const [currentKeyMap, setCurrentKeyMap] = useContext(HotKeyMappingContext);

  var _results = fullData && fullData.results ? fullData.results : []

  const _classes = useStyles();
  var submitButtonPropsInit: ButtonProps = {
    label: "Submit",
    variant: "raised",
    color: "primary",
  };

  var cancelButtonPropsInit: ButtonProps = {
    label: "Cancel",
    variant: "raised",
    color: "primary",
  };

  // var pageSizeInit: any;
  // var ps = CookieManager.getCookie(
  //   `queryListPageSizeInit|${window.location.pathname}`
  // );
  // if (ps != "") {
  //   pageSizeInit = Number(ps);
  //   if (isNaN(pageSizeInit)) {
  //     pageSizeInit = undefined;
  //   }
  // }

  const skipSSEBroadcast = () => {
    return (((window as any).App || {}).browserEnvironment || {BROWSER_ENABLE_SSE_BROADCAST: "false"}).BROWSER_ENABLE_SSE_BROADCAST != "true"
}

  useEffect(() => {
    handleProps(autoQuery ? true : false, forceExecuteOnLoad);
    if (!suppressURL) {
      URLManager.addOnChangeHandler((newVal: any) => {
        executeQuery();
      });
    }
  }, []);

  var listener: EventSource;

  useEffect(()=>{
    // TODO - figure out why this was added? This actually causes incorrect total count to be displayed.
    // if(fullData && fullData.results){
    //   setResultCount(fullData.results.length)
    // }
    if (!skipSSEBroadcast()){
      if (fullData && (fullData.results || []).length > 0 && sseActionProps && sseActionProps.eventFunction && sseActionProps.eventListenerURL) {
        listener = new EventSource(sseActionProps.eventListenerURL)
        listener.onmessage = (data) => {
          const dataJSON = JSON.parse(data.data, (k,v)=>{
              if (v && typeof v === "object"){
                return Object.assign(Object.create(null), v);
              }
              return v
          })
          onSSEEventReceived(dataJSON);
        }
      } else {
        if (listener) {
          listener.close()
        }
      }

      return ()=> {
        if (sseActionProps && sseActionProps.eventFunction && sseActionProps.eventListenerURL) {
          if (listener) {
            listener.close()
          }
        }
      }
    }
  }, [fullData])

  useEffect(() => {
    if (currentKeyMap && currentKeyMap.length > 0) {
        // The current keymap will be an array.  Loop over it
        for(let keyMap of currentKeyMap) {

            // Split the key action into parts
            var keyParts = keyMap.action.split(".")
            // If the first part, lowercased, is "formcontainer", then we know this is a key map relevent to the form container
            if (keyParts[0].toLowerCase() == "querylist" && keyParts.length > 1) {
              switch (keyParts[1].toLowerCase()) {
                case "clear":
                  handleClearClick();
              }
              // Only set the current key map to null if the key action was consumed
              // Set the current Key map to null, to reset for next key
              setCurrentKeyMap(null);
              break;


            }
        }

    }
  }, [currentKeyMap])  

  function onSSEEventReceived(message:any){
    if (sseActionProps && sseActionProps.eventFunction) {
      var newData = cloneDeep(fullData)      
      setStatus("paging")
      var d:any = sseActionProps.eventFunction(message, fullData)
      setFullData(d)
      setStatus("ready")
    }
  }

  const handleProps = (autoQuery: boolean, forceExecuteOnLoad?: boolean) => {
    var promises: Array<any> = [];
    var cfIdx = -1;
    var rfIdx = -1;

    if (!criteriaForm && criteriaFormSelector) {
      cfIdx = promises.length;
      promises.push(
        request.get(
          "/api/form-definitions/select?selector=" +
            URLManager.getQueryStringValue(criteriaFormSelector)
        )
      );
    } 

    if (!resultsForm && resultsFormSelector) {
      rfIdx = promises.length;
      promises.push(
        request.get(
          "/api/form-definitions/select?selector=" +
            URLManager.getQueryStringValue(resultsFormSelector)
        )
      );
    } else {
      setResultsForm(resultsForm);
    }

    if (promises.length > 0) {
      Promise.all(promises)
        .then((values) => {

          var crit: any;
          var _criteriaForm_: any;
          var _resultsForm_: any;

          if (!suppressURL) {
            crit = URLManager.getQueryString() || {};
          } else {
            crit = _criteria;
          }

          if (criteriaForm) {
            setCriteriaForm(criteriaForm);
          }
          if (resultsForm) {
            setResultsForm(resultsForm);
          }
          if (resultsColumns) {
            setResultsColumns(resultsColumns);
          }
          setCriteria(crit);
          
          if (cfIdx > -1) {
            if (!values[cfIdx].body) {
              const apiErr = new APIError();
              apiErr.type = "http";
              apiErr.message = "Invalid Criteria Form Definition";
              apiErr.details = "";
              setStatus("error");
              setError(apiErr);
              

              return;
            } else {
              _criteriaForm_ = new Definition(values[cfIdx].body);
              // This is the point that, if the user has passed a function on onCriteriaFormSelection, we should call it, transforming the form by reference
              if (onCriteriaFormSelection) {
                // _criteriaForm_ = onCriteriaFormSelection(_criteriaForm_);
                onCriteriaFormSelection(_criteriaForm_);
              }
              setCriteriaForm(_criteriaForm_);
            }
          } else {
            setCriteriaForm(criteriaForm);
            setResultsForm(resultsForm);
            setStatus("ready")
          }

          // This is the point that, if the user has passed a function on onCriteriaFormSelection, we should call it, transforming the form by reference
          // Moved this to above to line 766
          // if (onCriteriaFormSelection) {
          //   // onCriteriaFormSelection(_criteriaForm);
          // }

          if (rfIdx > -1) {
            if (!values[rfIdx].body) {
              const apiErr = new APIError();
              apiErr.type = "http";
              apiErr.message = "Invalid Results Form Definition";
              apiErr.details = "";
              setStatus("error");
              setError(apiErr);
              // setState(_state);
              return;
            } else {
              _resultsForm_ = new Definition(values[rfIdx].body);
              setResultsForm(_resultsForm_);
            }
          } else {
            _resultsForm_ = new Definition(resultsForm);
          }

          if (_resultsForm_) {
            setResultsForm(_resultsForm_);
          }

          if (!_criteriaForm_ || (!_resultsColumns && !_resultsForm_)) {
            const apiErr: any = new APIError(
              "http",
              "Invalid Form Configuration",
              JSON.stringify(criteriaFormSelector, null, "  ")
            );
            setStatus("error");
            setError(apiErr);
            return;
          }

          if (!values[cfIdx].body) {
            const apiErr: any = new APIError(
              "http",
              "Invalid Form Definition",
              JSON.stringify(resultsFormSelector, null, "  ")
            );
            setStatus("error");
            setError(apiErr);
            return;
          }

          if (_criteriaForm_ && _resultsForm_ && _resultsForm_.sortOptions) {
            _criteriaForm_.sortOptions = _resultsForm_.sortOptions;
            setCriteriaForm(_criteriaForm_);
          }
          setStatus("ready");
        })
        .catch((err) => {
          console.log("err", err)
          const apiErr = new APIError();
          apiErr.type = "http";
          apiErr.message = "Error fetching data during initialization";
          apiErr.details = (err.response || { text: err.toString() }).text;
          setStatus("error");
          setError(apiErr);
          return;
        });
    } else {
      if (!criteriaForm || (!resultsColumns && !resultsForm)) {
        const apiErr = new APIError(
          "http",
          "Invalid Form configuration",
          JSON.stringify(resultsFormSelector, null, "  ")
        );
        setStatus("error");
        setError(apiErr);
        return;
      } else {
        var crit: any;

        if (!suppressURL) {
          crit = URLManager.getQueryString() || {};
        } else {
          crit = _criteria || {};
        }

        if (criteriaForm && resultsForm && resultsForm.sortOptions) {
          criteriaForm.sortOptions = resultsForm.sortOptions;
        }

        // this.setState(
        //   {
        //     state.status = "ready"
        setCriteriaForm(new Definition(criteriaForm));
        // _resultsForm_ = new Definition(resultsForm);
        if (resultsColumns) {
          setResultsColumns(resultsColumns);
        }
        setCriteria(crit);
        setStatus("ready");

      }
    }
  };

  

  const handleClearClick = () => {
    setHasExecutedQuery(false);
    setCriteria({});
    setCurrentPage(0);
    setFullData([]);
    setPolicyMessages([])
    setError(null)
  };

  const handleFunctionDialogClose = () => {
    setDashboardConfig(null)
    setError(null)
  };

  const handleCardDialogComplete = () => {
      if (!(_dashboardConfig||{title:null}).title) {
        setError("A dashboard card title is required, please try again providing a title.")    
        return
      } else {
        setError(null)
      }
      // Reshape this here or do it server side.  We just need to make sure and provide the queryUrl, queryCriteria, etc.
      const e: any = {
        scope: "Private",
        title: _dashboardConfig.title,
        elementType: _dashboardConfig.elementType,
        fulfillmentURL: queryUrl,
        fulfillmentCriteria: _criteria,
        criteriaForm: criteriaForm,
        resultsForm: resultsForm,
      };

      // Set the targetURL for the reuslts handler
      _dashboardConfig.targetURL = window.location.pathname;

      // clean up the data that we do not need to embed into the elementAttributes
      var alteredDashboardConfig = cloneDeep(_dashboardConfig);
      delete alteredDashboardConfig.criteria;
      delete alteredDashboardConfig.scope;
      delete alteredDashboardConfig.elementType;
      delete alteredDashboardConfig.queryUrl;
      delete alteredDashboardConfig.type;
      delete alteredDashboardConfig.title;

      e.elementAttributes = alteredDashboardConfig;

      request
        .post("/api/dashboards")
        .set("Content-Type", "application/json")
        .send(JSON.stringify(e))
        .then((response) => {
          // Show the SuccessView
          if (
            response.body &&
            response.body.policyMessages &&
            response.body.policyMessages.length > 0
          ) {
            const apiErr = new APIError(
              "http",
              "One or more errors has occurred.",
              JSON.stringify(response.body.policyMessages, null, "  ")
            );
            setStatus("ready");
            setError(apiErr)
            setHasExecutedQuery(false)
            setDashboardConfig(null)
              
            // TODO - figure out why this would be needed??
            // setResults(response.body)

          } else {
            setSuccess("Card Successfully Added")
            setDashboardConfig(null)
            setError(null)
          }
        })
        .catch((err) => {
          const apiErr = new APIError();
          apiErr.type = "http";
          apiErr.message = (err.response || { text: err.toString() }).text;
          setDashboardConfig(null)
          setStatus("error");
          // setStatus("ready")
          setError(apiErr)
        });

    //
  };

  const handleDashboardConfigChange = (config: any, complete: boolean) => {
    setDashboardConfig(config)
    console.log(config)
  };


  const titleIsValid = () => {
    return !_dashboardConfig || !_dashboardConfig.title
  }
  const renderDashboardCardDialog = () => {
    // configElement and configElementType need to be added to state and managed

    if (!_dashboardConfig) {
      return null;
    }

    // This is only for temporary backward compatibility
    const configView = (
      <DashboardCardConfig
        onConfigChange={handleDashboardConfigChange}
        config={_dashboardConfig}
        results={_results}
      />
    );

    return (
      <Dialog
        className={_classes.modal}
        open={true}
        onClose={handleFunctionDialogClose}
      >
        <DialogTitle>Add to Dashboard</DialogTitle>
        <DialogContent
          style={{ minHeight: 300, minWidth: 300 }}
          className={_classes.modalContent}
        >
          <div>{configView}</div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleFunctionDialogClose}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            autoFocus={true}
            onClick={handleCardDialogComplete}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderSummaryDialog = (): any => {

    let selectedItems: Array<any> = [];

    if (
      _results &&
      _results.map &&
      _results.length > 0
    ) {
      selectedItems = _results.reduce(
        (acc: Array<any>, i: any): Array<any> => {
          if (i["_selected"]) {
            acc.push(i);
          }
          return acc;
        },
        []
      );
    }

    if (_summaryOperation && _summaryOperation.action) {
      if (_summaryOperation.action.onClick) {
        // _summaryOperation.action.onClick(selectedItems, this.refreshQueryResults)
        return;
      } else {
        return (
          <SummaryDialog
            title={_summaryOperation.action.label}
            onFormComplete={handleSummaryOpComplete}
            formSelector={_summaryOperation.action.formSelector}
            form={_summaryOperation.action.form}
            action={_summaryOperation.action}
            items={selectedItems}
          />
        );
      }
    }
  };

  const handleSummaryMenuClick = (event) => {
    setSummaryMenuAnchorEl(event.currentTarget)
    setSummaryMenuOpen(!_summaryMenuOpen)
  };

  const handleSummaryOpComplete = () => {
    setSummaryOperation(null)
  };

  const handleRowSelectToggle = (index: number) => (event: any) => {
    var cloneData = cloneDeep(fullData);

      if (cloneData && cloneData.results && cloneData.results[index]) {
        cloneData.results[index]["_selected"] = !cloneData.results[index]["_selected"]
      }
    setFullData(cloneData)
  };

  const handleSummarySelectAllClick = () => {
    var cloneData = cloneDeep(fullData);
    cloneData.results = cloneData.results.map((i) => {
      i["_selected"] = true;
      return i;
    });
    setFullData(cloneData)
  };

  const handleSummaryUnselectAllClick = () => {
    var cloneData = cloneDeep(fullData);
    cloneData.results = cloneData.results.map((i) => {
      delete i["_selected"];
      return i;
    });
    setFullData(cloneData)
  };

  const handleSummaryMenuClose = () => {
    setSummaryMenuAnchorEl(null)
    setSummaryMenuOpen(false)
  };

  const handleSummaryMenuItemClick = (action) => () => {

    if (
      fullData &&
      fullData.results &&
      fullData.results.reduce &&
      fullData.results.length > 0
    ) {
      const selectedItems =fullData.results.reduce((acc: Array<any>, i: any) => {
        if (i["_selected"]) {
          acc.push(i);
        }
        return acc;
      }, []);

      setSummaryMenuAnchorEl(null)
      setSummaryMenuOpen(false)
      setSummaryOperation({ action: action, items: selectedItems })
          if (action.onClick) {
            setTemplateRenderer((
              <TemplateDialog
                title="Loading..."
                data={{
                  count: selectedItems.length,
                  selectedItems: selectedItems,
                }}
                templateSelector={action.templateSelector}
                completeButtonText="Continue"
                handleCancel={() => {
                  setTemplateRenderer(null)
                }}
                handleComplete={() => {
                    setTemplateRenderer(null)
                    setStatus("loading")
                    setLoadingText("Performing Summary Action...")
                    action.onClick(selectedItems, refreshQueryResults);
                    
                }}
              />
            ))
          }

    } else {
      setSummaryMenuAnchorEl(null)
      setSummaryMenuOpen(false)
    }
  };

  const refreshQueryResults = (policyMessages: any) => {
    // const { criteria } = this.state;
    executeQuery(fullData, false, policyMessages);
  };

  const extractData = (contentType: string) => (evt: any) => {
    
    if (fullData && fullData.extractionAttributes && fullData.extractionAttributes.extractionDefinition ) { 
      // Added clone deep to avoid side effects to stick with the extractionAttributes
      setError(null)
      setExtractionDefinition(cloneDeep(fullData.extractionAttributes.extractionDefinition))
    };

  }

  const handleExtractDialogCancel = () => {
    //Just need to set the this.extractDefinition to nul to get the diaplog to disappear
    setExtractionDefinition(null)
  };


  const handleExtractDialogComplete = (def: Definition, dimensions: Array<any>) => {
    //Just need to set the this.extractDefinition to nul to get the diaplog to disappear

    // This is to prevent side effects from impacting other areas of the app.
    const crit = cloneDeep(_criteria);
    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    // The form is also part of the criteria, so make sure to set that as well.
    // This is used on the server to do server-side form validations.
    crit.criteriaForm = _criteriaForm;
    crit.resultsForm = _resultsForm;
    if (!crit.extractionOpts) {
      crit.extractionOpts = {};
    } 
    crit.extractionOpts.definition = def;
    crit.extractionOpts.dimensions = dimensions; 

    crit.skip = null
    crit.limit = null 

    var completionTimeout = 600000;

    if (queryTimeoutSec) {
      completionTimeout = queryTimeoutSec * 1000;
    }

    setLoadingExport(true);

    request
      .post(queryUrl || "")
      .set("Content-Type", "application/json")
      .send(JSON.stringify(crit))
      .set("Accept", contentType)
      .responseType("blob")
      .timeout({
        response: 600000,
        deadline: completionTimeout,
      })
      .then((response) => {
        let filename = crit.resultsForm.key + ".xlsx";

        let disposition = response["headers"]["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        // file saver module allows blob downloads for IE10+
        saveAs(response.body, filename);
      })
      .catch((err) => {
        const apiErr = new APIError();
        apiErr.type = "http";
        apiErr.message = "Error Exporting Extraction Data."
        apiErr.details = (err.response || { text: err.toString() }).text;
        setError(apiErr);
        setStatus("error");
      })
      .then(() => {
        setLoadingExport(false)
      });

    setExtractionDefinition(null)

  };

  const renderExtractDialog = () => {


    if (!_extractionDefinition) {
      return null;
    }

    return <DataExtractDialog extractionDefinition={_extractionDefinition} handleCancel={handleExtractDialogCancel} handleComplete={handleExtractDialogComplete} ></DataExtractDialog>
  };

  const addToDashboard = (evt: any) => {

    const crit = _criteria;

    // The form is also part of the criteria, so make sure to set that as well.
    // This is used on the server to do server-side form validations.
    // Add in the paging information, in addition to the criteria provided by users.
    crit.skip = _currentPage * pageSize;
    crit.limit = pageSize;

    const elementConfig = {
      //config defaults
      title: "",
      elementType: "count",
      layoutAttributes: {
        lg: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        md: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        sm: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        xl: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
        xs: {
          h: 8,
          i: "2",
          w: 3,
          maxW: 12,
          minW: 3,
          moved: false,
          static: false,
        },
      },
      fulfillmentUrl: queryUrl,
      fulfillmentCriteria: crit,
      criteriaForm: criteriaForm,
      resultsForm: resultsForm,
    };

    setDashboardConfig(elementConfig);
  };

  const renderHidableResultsDialog = () => {

    if (!_hidableResultsOpen) {
      return null;
    }

    var hrf = CookieManager.getCookie(
      `hiddenResultsFields|${window.location.pathname}`
    );

    var hiddenFields = []
    if (hrf) {
      hiddenFields = hrf.split("|")
    }  

    return <HidableResultsDialog resultsForm={_resultsForm} hiddenFields={hiddenFields} handleCancel={handleHideableResultsDialogCancel} handleComplete={handleHidabeResultsDialogComplete} ></HidableResultsDialog>
  };

  const handleHideableResultsDialogCancel = () => {
    //Just need to set the this.extractDefinition to nul to get the diaplog to disappear
    setHidableResultsOpen(false)
  };

  const handleHidabeResultsDialogComplete = (hiddenFields: Array<any>) => {
    
    //set the cookie with the new hidden field array
    CookieManager.setCookie(
      `hiddenResultsFields|${window.location.pathname}`,
      String(hiddenFields.join('|')),
      30
    );
  //Just need to set the this.hidableResultsOpen to false to close the dialog
    setHidableResultsOpen(false)
  };

  const handleHidableResultsClick = () => {
    setHidableResultsOpen(true)

  }

  const handleSubscribeClick = () => {
    setConfirmSubscribe(true)
  }

  const cancelSubscribe = () => {
    setConfirmSubscribe(false)
  }

  const renderSubscribeConfirm = () => {

    if (!_confirmSubscribe) {
      return null;
    }

    return (
      <Dialog
        className={_classes.modal}
        open={true}
        onClose={cancelSubscribe}
      >
        <DialogTitle>Create Email Subscription</DialogTitle>
        <DialogContent
          // style={{ minHeight: 300, minWidth: 300 }}
          className={_classes.modalContent}
        >
          <div>Would you like to create an email subscription?</div>
          <br></br>
          <div>You will be taken to the subscription setup page and guided through a short series of steps to configure your subscription. You will be brought back to this page at the conclusion of the subscription setup.</div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={cancelSubscribe}
            color="inherit"
          >
            No
          </Button>
          <Button
            autoFocus={true}
            onClick={handleSubscribe}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleSubscribe = () => {

    if (!history) {
      console.error(
        "When enabling subscription functionality by passing `subscriptionUrl`, you must also provide `history`."
      );
      return;
    }


    var excelColumns = new Array<any>();
    var columnData = new Array<any>();

    if (_resultsForm.predefined) {
      for (const f of _resultsForm.predefined) {
        excelColumns.push({
          headerText: f.title,
          attributeName: f.key,
        });
        columnData.push({
          label: f.title,
          id: f.key,
          numeric:
            f.type == "Numeric" || f.type == "Currency" || f.type == "Number"
              ? true
              : false,
        });
      }
    }

    // create a Subscription token and then redirect to the subscription edit view in the root.
    var criteria = cloneDeep(_criteria)
    delete criteria.limit
    delete criteria.skip
    
    const portalSub = new PortalUserSubscription({
      dataURL:
        queryUrl +
        `?q=${URLManager.getQueryStringValue(criteria)}`,
      status: "Active",  
      extendedAttributes: {
        columns: columnData,
        excelColumns: excelColumns,
      },
    });

    portalSub
      .save()
      .then((sub: PortalUserSubscription) => {
        window.location.href =
          "/subscriptions/" +
          sub.id.toString() +
          "/info" +
          "?return=" +
          encodeURI(window.location.href);
      })
      .catch((err: APIError) => {
        setError(err);
      });
  };


  useEffect(() => {
    if (_status == "ready") {
      executeQuery(null, true);
    }
  }, [_currentPage, _pageSize]);

  const handleChangePage = (newPage: number, newPageSize: number) => {
    if (newPageSize != _pageSize) {
      setCurrentPage(0);
      setPageSize(newPageSize);
    } else {
      setCurrentPage(newPage);
      setPageSize(newPageSize);
    }
  };


  const handleSubmit = (criteria: any) => {

    setTimeout(() => {
      if (alwaysExecuteOnSubmit) {
        // If we are always going to execute, we will set the URL amanger silently and trigger manually.
        executeQuery(criteria);

        if (!suppressURL) {
          var crit = clone(criteria);

          // We need to delete these since we do not need them on the URL and their length blows out the NGINX URL max length default setting
          if (crit) {
            delete crit.criteriaForm;
            delete crit.resultsForm;
            URLManager.putQueryString(crit, true);
            if(handleCriteriaChange != null){
              handleCriteriaChange("", crit)
            }
          }

        }
      } else {
        // Otherwise we will report the value and let the URL manager decide whether to report a change.
        if (!suppressURL) {
          var crit = clone(criteria);

          // We need to delete these since we do not need them on the URL and their length blows out the NGINX URL max length default setting
          delete crit.criteriaForm;
          delete crit.resultsForm;

          URLManager.putQueryString(crit);
          if(handleCriteriaChange != null){
            handleCriteriaChange("", crit)
          }
        }
      }
    }, 100);
  };

  const executeQuery = (
    crit?: any,
    newPage?: boolean,
    refreshWithPolicyMessages?: any
  ) => {
    setError(null)
    setHasExecutedQuery(true)
    if (!newPage) {
      setStatus("searching");
    } else {
      setStatus("paging")
    }

    if (!crit) {
      var qsCrit = URLManager.getQueryString() || {};
      crit = qsCrit
      setCriteria(crit);
    }

    crit.extractionOpts = {};
    crit.aggregationOpts = null;

    let cf: any = cloneDeep(_criteriaForm);

    if (pruneCriteriaForm && cf) {
      cf.predefined = cf.predefined.map((field) => {
        if (field.options) {
          field.options = [];
        }
        return field;
      });
    }

    crit.criteriaForm = cf;

  
    crit.resultsForm = _resultsForm || {};
    crit.skip = _currentPage * _pageSize;
    crit.limit = _pageSize;
    // Update the querystring
    const urlCrit = cloneDeep(crit);
    delete urlCrit.criteriaForm;
    delete urlCrit.resultsForm;
    URLManager.putQueryString(urlCrit, true);

    crit.resultsForm.extendedAttributes =
      crit.resultsForm.extendedAttributes || {};
    crit.resultsForm.extendedAttributes.browserTimezoneOffset =
      new Date().getTimezoneOffset();
    crit.resultsForm.extendedAttributes.browserTimezone =
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    var completionTimeout = 600000;
    var responseTimeout = 300000;

    request
      .post(queryUrl || "")
      .send(crit)
      .timeout({
        response: responseTimeout,
        deadline: completionTimeout,
      })
      .then((response) => {
        if (response.body) {
          var data: any = response.body;
          var newError = false
          if (
            response.body.policyMessages &&
            response.body.policyMessages.length > 0
          ) {
            newError = true
            const apiErr = new APIError(
              "http",
              "One or more errors has occurred.",
              JSON.stringify(response.body.policyMessages, null, "  ")
            );

            // Set Error
            setPolicyMessages(response.body.policyMessages)
            setError(apiErr);
            setStatus("error");
            setHideResults(true)
          } else {
            setPolicyMessages([])

            // Summary message Stuff
            if (
              refreshWithPolicyMessages != null &&
              refreshWithPolicyMessages.policyMessages != null &&
              refreshWithPolicyMessages.appendField != null &&
              refreshWithPolicyMessages.fieldMatcher != null &&
              refreshWithPolicyMessages.appendDelimiter != null
            ) {
              if (data && data.items) {

                data.items.forEach((i) => {
                  refreshWithPolicyMessages.policyMessages.forEach(
                    (pm) => {
                      if (
                        pm.policyEntityID ==
                        i[refreshWithPolicyMessages.fieldMatcher]
                      ) {
                        if (!i["_SummaryActionPolicyMessages"]) {
                          i["_SummaryActionPolicyMessages"] = [];
                        }
                        i["_SummaryActionPolicyMessages"].push(pm);
                        i[refreshWithPolicyMessages.appendField] =
                          pm.title +
                          (i[refreshWithPolicyMessages.appendField] !=
                          null
                            ? (refreshWithPolicyMessages.appendDelimiter ||
                                "|") +
                              i[refreshWithPolicyMessages.appendField]
                            : "");
                      }
                    }
                  );
                });
              }
            }

          }

          if (data) {
            const r: any = {
              results: data.items,
              summaries: data.summaries,
              aggregationAttributes: data.aggregationAttributes,
              extractionAttributes: data.extractionAttributes,
              metrics: data.metrics,
            };
            setResultCount(data.totalItemCount);
            setFullData(r);
          }
          if (!newError){
            setHideResults(false);
          }
          
          setStatus("ready");
          console.timeEnd("executeQuery");
        } else {
          //Catch error
          const apiErr = new APIError(
            "http",
            "Empty response body returned",
            JSON.stringify(crit, null, "  ")
          );
          // Set error
          setError(apiErr);
          setStatus("error");
          setHideResults(true)
        }
      }).catch((err:any)=>{
        // Set error
        setError(err);
        setStatus("ready");
        setHideResults(true)
      })
    
      return
  };

  const handleAddNew = () => {
    window.location.href = addNewUrl;
  };

  const exportList = (contentType: string) => (evt: any) => {
    // This is to prevent side effects from being exposed to other areas of the application.
    const crit = cloneDeep(_criteria);

    // The form is also part of the criteria, so make sure to set that as well.
    // This is used on the server to do server-side form validations.
    //crit.criteriaForm = criteriaForm;
    crit.resultsForm = _resultsForm;
    if(exportFileNameBase) {
      crit.resultsForm.exportFileNameBase = exportFileNameBase;
    }


    // Add in the paging information, in addition to the criteria provided by users.
    crit.skip = _currentPage * pageSize;
    crit.limit = pageSize;

    var completionTimeout = 600000;

    if (queryTimeoutSec) {
      completionTimeout = queryTimeoutSec * 1000;
    }

    setLoadingExport(true)

    request
      .post(queryUrl || "")
      .set("Content-Type", "application/json")
      .send(JSON.stringify(crit))
      .set("Accept", contentType)
      .set("LocalTimeZoneOffset", (new Date()).getTimezoneOffset())
      .responseType("blob")
      .timeout({
        response: 600000,
        deadline: completionTimeout,
      })
      .then((response) => {
        let filename = crit.resultsForm.key + ".xlsx";

        let disposition = response["headers"]["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        // file saver module allows blob downloads for IE10+
        saveAs(response.body, filename);
      })
      .catch((err) => {
        const apiErr = new APIError();
        apiErr.type = "http";
        apiErr.message = (err.response || { text: err.toString() }).text;
        setError(apiErr);
        setStatus("error");
      })
      .then(() => {
        setLoadingExport(false);
      });
  };

  const onSuccessViewClose = () => {
    setSuccess(null);
  };

  const onErrorClose = () => {
    // May need to do nothing instead to maintain functionality
    setError(null)
  };

  


  let ct = exportContentType;
  if (!ct) {
    ct = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  }

  // RENDER

  // console.log("FC QF")


  var errorView;
  if (_error) {
    errorView = (
      <ErrorView classes={{}} error={_error} onClose={onErrorClose} />
    );
  }

  var successView;
  if (_success) {
    successView = (
      <SuccessView
        message={_success}
        onClose={onSuccessViewClose}
        classes={{}}
      />
    );
  }
    var title = ""
    if (_resultsForm && _resultsForm.title) {
      title = _resultsForm.title
    }
    if (resultsTitleOverride) {
      title = resultsTitleOverride
    }

    let allowExtraction = false
    if (fullData && fullData.extractionAttributes && fullData.extractionAttributes.extractionDefinition ) { 
      allowExtraction = true
    }
  
    let allowHidableResults = false
    if (_resultsForm && _resultsForm.hidableResults ) { 
      allowHidableResults = true
    }

    var showResultsTitle = fullData && fullData.results && fullData.results.reduce && fullData.results.length > 0
  var tp = (
    <div name="QueryListResults" className={_classes.listFunctionLine}>
    {showResultsTitle && <Typography className={_classes.listTitle} variant="h6">
      {title}
    </Typography>}
    {_results && _results.length > 0 && (
      <div className={_classes.listFunctions}>

        {allowHidableResults && !_loadingExport && (
          <Tooltip
            enterDelay={200}
            id="hidable-results-tooltip"
            placement="top-end"
            title="Customize Visible Fields"
          >
            <IconButton
              className={_classes.listFunctionButton}
              aria-label="Customize Visible Fields"
              color="inherit"
              onClick={handleHidableResultsClick}
            >
              <i
                style={{ minWidth: "1rem" }}
                className={"fa fa-eye-slash"}
              />
            </IconButton>
          </Tooltip>
        )}

        {allowExtraction && (
          <Tooltip
            enterDelay={200}
            id="extract-tooltip"
            placement="top-end"
            title="Extract Data From Results"
          >
            <IconButton
              className={_classes.listFunctionButton}
              aria-label="Extract Data From Results"
              color="inherit"
              onClick={extractData(ct)}
            >
              <i
                style={{ minWidth: "1rem" }}
                className={"fa fa-cubes"}
              />
            </IconButton>
          </Tooltip>
        )}
        
        {!suppressExport && !_loadingExport && (
          <Tooltip
            enterDelay={200}
            id="export-tooltip"
            placement="top-end"
            title="Export Results"
          >
            <IconButton
              size="small"
              className={_classes.listFunctionButton}
              aria-label="Export Results"
              color="primary"
              onClick={exportList(ct)}
            >
              <i
                style={{ minWidth: "1rem" }}
                className={"fa fa-download"}
              />
            </IconButton>
          </Tooltip>
        )}

        {!suppressExport && _loadingExport && (
          <Tooltip
            enterDelay={200}
            id="export-tooltip"
            placement="top-end"
            title="Export Results"
          >
            <IconButton
              className={_classes.listFunctionButton}
              aria-label="Export Results"
              color="primary"
              disabled={true}
              size="small"
              onClick={exportList(ct)}
            >
              <i
                style={{ minWidth: "1rem" }}
                className={"fas fa-spinner fa-spin"}
              />
            </IconButton>
          </Tooltip>
        )}

        {allowSubscription && PortalUserContext.hasOneOfFeatures(["subscription_create"]) && (
          <Tooltip
            enterDelay={200}
            id="subscribe-tooltip"
            placement="top-end"
            title="Subscribe"
          >
            <IconButton
              className={_classes.listFunctionButton}
              aria-label="Subscribe"
              color="primary"
              onClick={handleSubscribeClick}
              size="small"
            >
              <i className={"fa fa-envelope"} />
            </IconButton>
          </Tooltip>
        )}
        
        {!suppressDashboardCard && (
          <Tooltip
            enterDelay={200}
            id="dashboard-card-tooltip"
            placement="top-end"
            title="Add to Dashboard"
          >
            <IconButton
              className={_classes.listFunctionButton}
              aria-label="Add to Dashboard"
              color="primary"
              size="small"
              onClick={addToDashboard}
            >
              <i className={"fa fa-address-card"} />
            </IconButton>
          </Tooltip>
        )}
      </div>
    )}
    </div>
  );

  let selectionActionArea: any = null;
  var selectedItems = []
  if (fullData && fullData.results && fullData.results.reduce && fullData.results.length > 0) {
    selectedItems = fullData.results.reduce((acc: Array<any>, i: any) => {
      if (i["_selected"]) {
        acc.push(i);
      }
      return acc;
    }, []);
  }

  if (actionsForSelectedItems) {
    let actionButton: any = null;
    const actions: any = actionsForSelectedItems(selectedItems);
    var displaySummaryActionButton: boolean = true;
    // Make sure a template and form selector where not provided for any options
    if (actions && actions.length > 0) {
      actions.forEach((a) => {
        if (a.templateSelector && a.formSelector) {
          displaySummaryActionButton = false;
          console.warn(
            "templateSelector and formSelector are mutually exclusive form summary actions, please use one or the other"
          );
        }
      });
    }

    if (displaySummaryActionButton && actions && actions.length > 0) {
      const ab = (
        <Button
          className={"query-list-selection-action"}
          aria-label="Selected Items Action Menu"
          aria-controls="customized-menu"
          aria-haspopup="true"
          variant="contained"
          color="primary"
          onClick={handleSummaryMenuClick}
        >
          {selectedItems.length} Selected{" "}
          <i style={{ marginLeft: 10 }} className="far fa-chevron-down" />
        </Button>
      );

      let actionItems: Array<any> = actions.map((a: any, idx: number) => {
        return (
          <StyledMenuItem key={idx}>
            <ListItemText
              className={_classes.hover}
              onClick={handleSummaryMenuItemClick(a)}
            >
              {a.label}
            </ListItemText>
          </StyledMenuItem>
        );
      });


      if (selectedItems.length > 0) {
        // only show the summary actions if you have items selected
        actionButton = (
          <div>
            {ab}
            <StyledMenu
              id="customized-menu"
              className={"query-list-summary-action-menu"}
              anchorEl={_summaryMenuAnchorEl}
              keepMounted
              open={_summaryMenuOpen}
              onClose={handleSummaryMenuClose}
              onClick={handleSummaryMenuClick}
            >
              {actionItems}
            </StyledMenu>
          </div>
        );
      }
    }

    selectionActionArea = (
      <div>
        <div className={_classes.selectionActionArea}>
          <div className={_classes.allSelectors}>
            <div
              className={_classes.select}
              onClick={handleSummarySelectAllClick}
            >
              <i aria-label="Select All" className={"far fa-check-square " + _classes.selector} />{" "}
              Select All
            </div>
            <div
              className={_classes.unselect}
              onClick={handleSummaryUnselectAllClick}
            >
              <i aria-label="Unselect All" className={"far fa-square " + _classes.selector} /> Unselect
              All
            </div>
          </div>
          <div className={_classes.selectionCount}></div>
          <div className={_classes.selectionAction}>{actionButton}</div>
        </div>
        <div className={_classes.summaryActionMessage}>
          {summaryActionMessage}
        </div>
      </div>
    );
  }

  //
  // Render the summary dialog, if appropriate
  var sd: any = null;
  sd = renderSummaryDialog();

  // Render the Dashboard Card Management Dialog, if appropriate
  var dbc: any = null;
  if (!sd) {
    // Only allow this dialog if the summary dialog is not showing
    dbc = renderDashboardCardDialog();
  }

  // Render the Data Extraction Management Dialog, if appropriate
  var ebc: any = null;
  if (!sd && !dbc) {
    // Only allow this dialog if the no other dialogs are showing 
    ebc = renderExtractDialog();
  }

  // Render the Hidable Results Dialog, if appropriate
  var hrd: any = null;
  if (!sd && !dbc && !ebc) {
    // Only allow this dialog if the no other dialogs are showing 
    hrd = renderHidableResultsDialog();
  }

  var subscribeConfirm: any = null;
  subscribeConfirm = renderSubscribeConfirm();

  // render the custom section, if appropriate
  var CustomSectionRenderer: any = null;
  if (customSectionRenderer) {
    CustomSectionRenderer = Renderers.find(customSectionRenderer)
  }

  var resultsSection= (<Paper className={_classes.resultsSection}>
          {tp}
          {selectionActionArea}
          <DefinitionDataProvider 
            overrideFullData={fullData} 
            overrideSetFullData={setFullData}
          >
          {_status == "paging" && <div
                style={{
                  top: "50%",
                  left: "50%",
                  zIndex: 9999,
                  position: "fixed",
                }}
                className="loader fa fa-3x fa-spin fa-sync"
              ></div>}
          <div style={{opacity: _status == "paging" ? .3 : 1}}>
            <QueryResultView
              currentStatus={_status}
              resultItemDef={_resultsForm}
              reserveRowActionSpace={reserveRowActionSpace}
              noResultsText={noResultsText}
              hasExecutedQuery={_hasExecutedQuery}
              actionsForItemRow={actionsForItemRow}
              actionsForSelectedItems={actionsForSelectedItems}
              onSelectionChange={handleRowSelectToggle}
              getNoResultsText={getNoResultsText}
              handleChangePage={handleChangePage}
              selected={false}
              onRowClick={onRowClick}
              customRenderers={customRenderers}
            />
          </div>
        </DefinitionDataProvider>
        {((fullData || {}).results || []).length > 0 && !suppressPaging && <div className={_classes.pagerArea}>
            <div className={_classes.pager}>
              <Pager
                page={_currentPage}
                pageSize={_pageSize || 10}
                count={_resultCount}
                onChangePage={handleChangePage}
                disallowScrollTop={disallowScrollTop}
              />
            </div>
          </div>}
        
        </Paper>)

        var addNewSection = (
          <Paper className={_classes.addNewSection} >
            {addNewUrl && (
            <div className={_classes.addNewRow}>
              <Button
                id="addNewButton"
                variant="contained"
                color="primary"
                className={_classes.buttonAddNew}
                onClick={handleAddNew}
              >
                Add New
              </Button>
            </div>
          )}
          </Paper>
        )
        var summaries: any = null
        if (fullData.summaries) {
          summaries = (
            <Paper elevation={0} className={_classes.summaries}>
              <Typography className={_classes.listTitle} variant="h6">
                Summaries
              </Typography>
              <QueryResultsSummaryArea summaries={fullData.summaries} />
            </Paper> 
          );
        }

  if (_status == "loading") {
    return (
      <div className={_classes.container}>
        <LoadingView title={_loadingText} classes={{}} />
      </div>
    );
  }
  
  return (
    <div className="query-list-fc">
      <React.Fragment>
        {(_status == "ready" || _status == "paging" ||
          _status == "searching") &&
          _criteriaForm && (
            <DefinitionDataProvider
              overridePolicyMessages={policyMessages}
              overrideSetPolicyMessages={setPolicyMessages}
              overrideFullData={_criteria} 
              overrideSetFullData={setCriteria}
            >
              <QueryCriteriaView
                preventCollapse={preventCollapse}
                suppressCriteriaView={suppressCriteriaView}
                defaultCollapsed={defaultCriteriaCollapsed}
                criteriaDef={_criteriaForm}
                submitButtonText={submitButtonText}
                submitButtonProps={submitButtonProps}
                excludeFromClear={excludeFromClear}
                forceExecuteOnLoad={forceExecuteOnLoad}
                autoQuery={autoQuery}
                criteriaTitleOverride={criteriaTitleOverride}
                onHandleSubmit={handleSubmit}
                hasExecutedQuery={_hasExecutedQuery}
                variant={variant}
                alphabetizeSortOptions={alphabetizeSortOptions}
                onHandleClearClick={handleClearClick}
                classes={_classes}
                triggerSubmit={handleSubmit}
                customRenderers={customRenderers}
              ></QueryCriteriaView>
            </DefinitionDataProvider>
          )}

          {CustomSectionRenderer && <CustomSectionRenderer executeQuery={executeQuery}/>}
          
      <div className={_classes.container}>

        {_status == "searching" && <LoadingView classes={{}} />}
        {_status != "searching" && _hasExecutedQuery && !hideResults && summaries}
        {_status != "searching" && _hasExecutedQuery && !hideResults && resultsSection}
        {_status != "searching" && addNewUrl && addNewSection}
        {hrd}
        {ebc}
        {dbc}
        {sd}
        {subscribeConfirm}
        
        

      </div>
      
        {errorView}
        {successView}
        {_templateRenderer}
      </React.Fragment>
      {/* )} */}
    </div>
  );
}; // End of FC

export default QueryList;